import { Mobile, PC, Tablet, Notebook } from "../../views/ReactiveMode"

const PageHeader = ({ title, subtitle, backgroundClass }) => {
  return (
    <>
      <PC>
        <div className={`${backgroundClass || "department-header"} department-header`}>
          <div className="overlay"></div>
          <div className="header-content">
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
        </div>
      </PC>

      <Notebook>
        <div className={`${backgroundClass || "department-header"} department-header`}>
          <div className="overlay"></div>
          <div className="header-content">
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
        </div>
      </Notebook>

      <Tablet>
        <div className={`${backgroundClass || "department-header"} department-header`} style={{ height: "250px" }}>
          <div className="overlay"></div>
          <div className="header-content">
            <h1 style={{ fontSize: "2.5rem" }}>{title}</h1>
            <p style={{ fontSize: "1.2rem" }}>{subtitle}</p>
          </div>
        </div>
      </Tablet>

      <Mobile>
        <div className={`${backgroundClass || "department-header"} department-header`} style={{ height: "200px" }}>
          <div className="overlay"></div>
          <div className="header-content">
            <h1 style={{ fontSize: "2rem" }}>{title}</h1>
            <p style={{ fontSize: "1rem" }}>{subtitle}</p>
          </div>
        </div>
      </Mobile>
    </>
  )
}

export default PageHeader
